/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import moment from 'moment-timezone';
import config from '../../../../../config';
import HistoryLists from './HistoryLists';
import { DateCell, DateRangeCell, MoneyCell } from './TableCells';

const History = ({
  summary,
  history,
  showHistory,
  setShowHistory,
  expanded,
  setExpanded,
  pagination,
  loadMore,
  loading,
}) => {
  return (
    <div className="u-mt+">
      <button className="c-btn u-mb+" onClick={() => setShowHistory(!showHistory)}>
        History
      </button>
      <div display-if={showHistory}>
        <ReactTable
          defaultPageSize={10000}
          data={summary}
          showPagination={false}
          minRows={0}
          className="c-table-new c-table--small c-table--border c-no-hover"
          expanded={expanded}
          columns={[
            {
              Header: 'Date Of Payout',
              accessor: 'transferDate',
              id: 'transferDate',
              className: 'u-text-center c-table-card__row--clickable',
              Cell: DateCell,
            },
            {
              Header: 'Date Range',
              id: 'dateRange',
              className: 'u-text-center c-table-card__row--clickable',
              Cell: DateRangeCell,
            },
            {
              Header: 'Total Transferred To Barbers',
              accessor: 'barberAmount',
              Cell: MoneyCell,
              className: 'u-text-center',
            },
            {
              Header: 'Total Transferred To Shop',
              accessor: 'shopAmount',
              Cell: MoneyCell,
              className: 'u-text-center c-table-card__row--clickable',
            },
          ]}
          SubComponent={(row) => {
            const items = history[moment(row.original.fromDate).format(config.dateFormatISO)];
            return (
              <HistoryLists
                items={items.filter((item) => !!item.barberId || item.unassigned)}
                shopPayout={items.find((item) => !item.barberId && !item.unassigned)}
              />
            );
          }}
          getTrProps={(state, rowInfo) => {
            return {
              onClick: () => {
                setExpanded({
                  ...expanded,
                  [rowInfo.viewIndex]: !expanded[rowInfo.viewIndex],
                });
              },
            };
          }}
        />
        {pagination && pagination.hasMore && (
          <div className="u-mt+ u-text-center">
            <button className="c-btn c-btn--ghost c-btn--medium" onClick={loadMore} disabled={loading}>
              {loading ? 'Loading...' : 'Show more payouts'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

History.propTypes = {
  summary: PropTypes.array,
  history: PropTypes.object,
  showHistory: PropTypes.bool,
  setShowHistory: PropTypes.func,
  expanded: PropTypes.object,
  setExpanded: PropTypes.func,
  pagination: PropTypes.object,
  loadMore: PropTypes.func,
  loading: PropTypes.bool,
};

History.defaultProps = {
  summary: [],
  history: {},
  showHistory: false,
  setShowHistory: () => {},
  expanded: {},
  setExpanded: () => {},
  pagination: null,
  loadMore: () => {},
  loading: false,
};

export default History;
